const api = {
    login: async (username, password) => {
        const response = await fetch('https://dhahabjw.com/api/admin/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ username, password }),
        });
        return response.json();
    },

    getProfile: async (token) => {
        const response = await fetch('https://dhahabjw.com/api/admin/profile', {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        return response.json();
    },

    changePassword: async (token, currentPassword, newPassword) => {
        const response = await fetch('https://dhahabjw.com/api/admin/change-password', {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ currentPassword, newPassword }),
        });
        return response.json();
    },

    // Product APIs
    getProducts: async (params = {}) => {
        const queryParams = new URLSearchParams();
        Object.keys(params).forEach(key => {
            if (params[key]) queryParams.append(key, params[key]);
        });

        const response = await fetch(`https://dhahabjw.com/api/admin/products?${queryParams}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('adminToken')}`,
            },
        });
        return response.json();
    },

    getProduct: async (id) => {
        const response = await fetch(`https://dhahabjw.com/api/admin/products/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('adminToken')}`,
            },
        });
        return response.json();
    },

    createProduct: async (productData) => {
        const response = await fetch('https://dhahabjw.com/api/admin/products', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('adminToken')}`,
            },
            body: productData
        });
        return response.json();
    },

    updateProduct: async (id, productData) => {
        const response = await fetch(`https://dhahabjw.com/api/admin/products/${id}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('adminToken')}`,
            },
            body: productData
        });
        return response.json();
    },

    deleteProduct: async (id) => {
        const response = await fetch(`https://dhahabjw.com/api/admin/products/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('adminToken')}`,
            },
        });
        return response.json();
    },

    permanentDeleteProduct: async (id) => {
        const response = await fetch(`https://dhahabjw.com/api/admin/products/${id}/permanent`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('adminToken')}`,
            },
        });
        return response.json();
    }
};

export default api;